
























import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Tree } from 'element-ui';
import { APP } from '@/api/com/MetaPattern/MDA/MD/Base/APP';
import { BaseElement } from '@/api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { TreeNode } from '@/libs/com/MetaPattern/Product/IDE/Util/TreeNode';
import { Diagram } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Diagram';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { MDExtendService } from '@/libs/com/MetaPattern/MDA/MD/MDExtendService';
import { EnumComponentType } from '@/api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { DataTypeManager } from '@/libs/com/MetaPattern/MDA/MD/DataTypeManager';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import { IDEProgram } from '@/libs/com/MetaPattern/Product/IDE/IDEProgram';

@Component({
  components: {
  }
})
export default class DataTypeExplorer extends Vue {
  @Prop() private value: string | BaseElement;
  @Prop() private includePlatType: boolean; // 是否包含平台类型
  @Prop() private beTypes: number; // 实体组件类型过滤，0代表所有类型，使用枚举EnumBEType的值之和
  @Prop() private isSelfAPP: boolean; // 是否只是自己应用下的类型，对于数据类型为Reference，这个值为true
  private filterText = '';
  filterNode(value: any, data: any) {
    if (!value) return true;
    return data.label.toUpperCase().indexOf(value.toUpperCase()) !== -1;
  }

  @Watch('filterText')
  filter(val: string) {
    (this.$refs.tree as Tree).filter(val);
  }

  get defaultProps() {
    return {
      children: 'children',
      label: 'label',
      id: 'id',
      isLeaf: 'isLeaf'
    };
  }

  get treeData() {
    const component = this.$store.state.ModuleMD.curComponent as BaseComponent;
    const apps = this.$store.state.ModuleMD.apps as Array<APP>;
    const comTrees = new Array<TreeNode<BaseElement>>();
    if (this.includePlatType) {
      // 这里可以加入预置可引用的类型，比如infrastructure中的数据类型等
      // comTrees.push(new TreeNode<BaseElement>('platDataType', '平台数据类型', '', false, null));
    }
    const infrastructureAPP = apps.find(item => item.aPPKey === IDEProgram.instance.InfrastructureAPPKey);
    if (infrastructureAPP) {
      const appNode = new TreeNode<BaseElement>(infrastructureAPP.designId, infrastructureAPP.rootNamespace, '', false, infrastructureAPP);
      comTrees.push(appNode);
      infrastructureAPP.bEComponents.forEach(be => {
        const beCom = new TreeNode<BaseElement>(be.designId, be.rootNamespace, '', false, be);
        appNode.children.push(beCom);
      });
    }
    // const app = apps.find(item => item.id === component.aPP_ID);
    // if (app) {
    apps.forEach(app => {
      if (app.aPPKey !== IDEProgram.instance.InfrastructureAPPKey) {
        if (!this.isSelfAPP || (this.isSelfAPP && component && component.aPP_ID === app.id)) {
          const appNode = new TreeNode<BaseElement>(app.designId, app.rootNamespace, '', false, app);
          comTrees.push(appNode);
          app.bEComponents.forEach(be => {
            const beCom = new TreeNode<BaseElement>(be.designId, be.rootNamespace, '', false, be);
            appNode.children.push(beCom);
          });
        }
      }
    // }
    });
    return comTrees;
  }

  async getComponentTrees(designId: string, componentType: EnumComponentType): Promise<Array<TreeNode<BaseElement>>> {
    // TODO : ModuleMD中elements的component，是获取应用的时候放入的，没有旗下的实体等信息。在打开模型的时候，应该要更新下面的内容
    let trees: Array<TreeNode<BaseElement>> = null;
    const diagram = this.$store.state.ModuleMD.diagrams.find((item: Diagram) => item.component.designId === designId);
    let component: BaseComponent;
    if (diagram && diagram.component !== null) {
      component = diagram.component;
      trees = MDExtendService.buildDataTypeTree(component, this.beTypes);
    } else {
      return new Promise((resolve, reject) => {
        Diagram.loadAsync(designId, componentType)
          .then((response: Diagram) => {
            this.$store.dispatch('ModuleMD/setDiagramAction', response);
            trees = MDExtendService.buildDataTypeTree(response.component, this.beTypes);
            resolve(trees);
          })
          .catch(error => {
            // TODO : 格式化错误返回
            reject(error);
          });
      });
    }
    return new Promise((resolve) => resolve(trees));
  }

  loadNode(node: any, resolve: any) {
    if (node.level === 0) {
      return resolve(this.treeData);
    }

    if (node.data.children.length > 0) {
      return resolve(node.data.children);
    }
    // if (node.level === 1) {
    if (node.data.id === 'platDataType') {
      resolve(DataTypeManager.instance.getPlatDataTypes());
    } else {
      this.getComponentTrees(node.data.id, node.data.data.componentType)
        .then((trees) => {
          if (trees !== null) {
            resolve(trees);
          }
        });
    }
    // } else {
    //   return resolve(node.data.children);
    // }
  }

  handleNodeClick(data: any, node: any, view: any) {
    if (data.nodeValue && data.nodeValue !== '') {
      this.$emit('onSelectDataType', data);
    }
  }
}
